import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { SET_ROSTER_HISTORY, SHOW_ROSTER_HISTORY_LOADING_SPINNER } from '../actions/rosterHistoryActions';
import { TRosterHistoryClientState } from '../libs/store';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

const initialState: TRosterHistoryClientState = {
  isLoading: false,
  history: [],
  scopeDays: 0,
  isLoaded: false
};

const rosterHistoryReducer = (
  state: TRosterHistoryClientState = initialState,
  action: TAction<any>
): Partial<TRosterHistoryClientState> => {
  switch (action.type) {
    case SHOW_ROSTER_HISTORY_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload,
        isLoaded: !action.payload
      };
    }
    case SET_ROSTER_HISTORY: {
      return {
        ...state,
        history: action.payload.history,
        scopeDays: action.payload.scopeDays
      };
    }
    case LOCATION_CHANGE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default rosterHistoryReducer;
